/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type StorefrontContactModal_seller$ref = any;
export type StorefrontContactModal_seller = {
    readonly sellerPreferences: {
        readonly displayStoreAddress: unknown | null;
        readonly storeAddressByAppointmentOnly: unknown | null;
    } | null;
    readonly sellerProfile: {
        readonly company: string | null;
    } | null;
    readonly shippingAddress: {
        readonly line1: string | null;
        readonly line2: string | null;
        readonly displayCountry: string | null;
        readonly displayCityStateZip: string | null;
    } | null;
    readonly tradeAssociations: ReadonlyArray<{
        readonly displayName: string | null;
    } | null> | null;
    readonly " $refType": StorefrontContactModal_seller$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "StorefrontContactModal_seller",
    "type": "Seller",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "sellerPreferences",
            "storageKey": null,
            "args": null,
            "concreteType": "SellerPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "displayStoreAddress",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "storeAddressByAppointmentOnly",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "sellerProfile",
            "storageKey": null,
            "args": null,
            "concreteType": "SellerProfile",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "company",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "shippingAddress",
            "storageKey": null,
            "args": null,
            "concreteType": "Address",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "line1",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "line2",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "displayCountry",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "displayCityStateZip",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "tradeAssociations",
            "storageKey": null,
            "args": null,
            "concreteType": "TradeAssociation",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "displayName",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'cafb8927ec756212aea69ec0d8198adf';
export default node;
